import {Component} from '@angular/core'
import { UserActions } from '../../actions/user-actions'
import { AccountActions } from '../../actions/account-actions'
import { Title } from '@angular/platform-browser'
import { ActivatedRoute } from '@angular/router'

@Component({
  selector: 'new-account-page',
  template: `
    <div class="left-nav-layout header-layout">
      <nav-bar></nav-bar>
      <div class="content-wrapper">
        <div id="left-nav" class="left-nav">
          <customers-nav></customers-nav>
        </div>
        <div id="detail-content" class="detail-content">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  `
})
export class NewAccountPage {
  constructor(userActions: UserActions,
              accountActions: AccountActions,
              title: Title) {
    userActions.loadUser()
    accountActions.loadAccount()
    title.setTitle('Dashboard - Signup')
  }
}
